import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the cost centers this user may report Lost/Damaged items for (spGetCSKCCs —
// same SP the Items Transfer page uses for its From CC list). CCID is already the
// plain CC code (e.g. "CC-33"), so no further parsing of CCVAL is needed.
export const getCentralCostCenterMenu = async (UID, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetCentralCostCenterMenu?UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the CC's type (Performing / Capital / etc.) — informs downstream Asset rules
export const getCostCenterType = async (CCType) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetCostCenterType?CCType=${encodeURIComponent(CCType)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET item categories for the search-by-category dropdown, scoped to a cost center
export const getCategories = async (CType) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetIndentcategoriesDetails?CType=${encodeURIComponent(CType)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET item search autocomplete (Typ: '1' = by code, '2' = by name)
export const getAutoCompleteItemTransfer = async (Pfx, Typ, Cat, CC) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetAutoCompleteItemTransfer?Pfx=${encodeURIComponent(Pfx)}&Typ=${encodeURIComponent(Typ)}&Cat=${encodeURIComponent(Cat)}&CC=${encodeURIComponent(CC)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the main grid — every current stock item at a CC, with any already-staged
// Lost/Damaged quantities filled in from a prior NewLDItemsIssueTempDetails add
export const getLostOrDamageItem = async (CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetLostOrDamageItem?CCCode=${encodeURIComponent(CCCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the lot-level breakdown for one searched item at a CC — the user enters
// Lost/Damaged quantity per lot here before it's rolled up into the main grid
export const getNewLDItemsIssueTempDetails = async (Itemcode, CCcode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/NewLDItemsIssueTempDetails?Itemcode=${encodeURIComponent(Itemcode)}&CCcode=${encodeURIComponent(CCcode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — commit the per-lot Lost/Damaged quantities into the main grid
// payload: { Trowids, TItemCodes, TNewLQtys, TNewDQtys, TNewTotalQtys, Ttblnames, TCCCode, TSingleItemcode }
export const saveTempNewItemsLD = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveTempNewItemsLD`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — remove a staged item from the main grid
// payload: { itemcode, CCCode }
export const deleteLDItems = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/DeleteLDItems`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the Lost/Damaged report for every staged row
// payload: { CCCode, itemcodes, Reporttype, itemids, Lostqtys, Damangedqtys, Stocktype,
//            Remarks, AvlQtys, Date, UserRemarks, Filechk, Extension }
export const insertLostorDamageMultipleItem = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/InsertLostorDamageMultipleItem`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
